import React, { useEffect, useState } from "react";
import BackHandSharpIcon from '@mui/icons-material/BackHandSharp';
import { Portal } from "./components/Portal";

const isPublicResumeRoute = () =>
    /^\/resume\/[^/]+/i.test(window.location.pathname || "");

const isDevRuntime =
    typeof process !== "undefined" && process.env.NODE_ENV === "development";

const AdblockDetector = () => {
    const [adblockStatus, setAdblockStatus] = useState(false); // Default to false (no adblock)
    const isPublicResume = isPublicResumeRoute();

    useEffect(() => {
        // Skip AdSense probe in local/dev — failed cross-origin ads scripts surface as
        // opaque "Script error." and trip CRA's runtime error overlay.
        if (isPublicResume || isDevRuntime) return undefined;

        const existingScript = document.querySelector(
            'script[data-wlj-ads], script[src*="pagead2.googlesyndication.com"]'
        );

        if (existingScript) {
            if (existingScript.dataset.loaded === "true" || window.adsbygoogle) {
                setAdblockStatus(false);
                return undefined;
            }

            const handleLoad = () => setAdblockStatus(false);
            const handleError = (event) => {
                event?.preventDefault?.();
                setAdblockStatus(true);
            };

            existingScript.addEventListener("load", handleLoad);
            existingScript.addEventListener("error", handleError);

            return () => {
                existingScript.removeEventListener("load", handleLoad);
                existingScript.removeEventListener("error", handleError);
            };
        }

        const scriptElement = document.createElement("script");
        scriptElement.type = "text/javascript";
        scriptElement.async = true;
        // Do not set crossOrigin — AdSense CDN + CORS yields opaque "Script error."
        scriptElement.setAttribute("data-wlj-ads", "true");
        scriptElement.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8691062301030113";

        scriptElement.onload = () => {
            scriptElement.dataset.loaded = "true";
            setAdblockStatus(false);
        };

        scriptElement.onerror = (event) => {
            event?.preventDefault?.();
            setAdblockStatus(true);
        };

        document.body.appendChild(scriptElement);

        return undefined;
    }, [isPublicResume]);

    useEffect(() => {
        if (isPublicResume || isDevRuntime) return;

        if (adblockStatus) {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
            document.body.classList.add('modal-open'); // When a modal opens
        } else {
            document.body.style.overflow = 'unset';
            document.documentElement.style.overflow = '';
            document.body.classList.remove('modal-open'); // When a modal closes
        }
    }, [adblockStatus, isPublicResume]);

    // Public resume, local/dev, and pages without adblock stay usable.
    if (isPublicResume || isDevRuntime || !adblockStatus) return null;

    return (
        <Portal layer="modal">
        <div
            className="modal fade show postAdd wlj-overlay-modal"
            tabIndex="-1"
            role="dialog"
            style={{ display: "flex" }}
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content d-flex justify-content-around p-2">
                    <div className="d-flex justify-content-between align-items-center p-2">
                        <div>
                            <h4 className="text-center AdBlocker">Adblocker Detected!</h4>
                            <p className="text-center ad-p">
                                Our website is made possible by displaying online advertisements to our visitors. Please consider supporting us by disabling your ad blocker on our website.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </Portal>
    );
};

export default AdblockDetector;
